import React, { FC, useCallback } from 'react';

import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardDatePickerProps
} from '@material-ui/pickers';

const DatePicker: FC<Omit<
  KeyboardDatePickerProps,
  'autocomplete' | 'variant' | 'size' | 'inputVariant' | 'fullWidth' | 'margin' | 'disableToolbar'
>> = ({ onChange, format = 'MM/dd/yyyy', value, ...field }) => {
  const handleChange = useCallback(
    (date: Date | null): void => {
      onChange(date);
    },
    [onChange]
  );

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        disableToolbar
        autoComplete="off"
        variant="inline"
        inputVariant="outlined"
        size="small"
        format={format}
        margin="normal"
        value={value}
        onChange={handleChange}
        {...field}
      />
    </MuiPickersUtilsProvider>
  );
};

export default DatePicker;
